import { PayloadAction, createSlice           } from '@reduxjs/toolkit';


import { RadioGroupItem                       } from 'src/components/common/radio-group';
import { RADIO_ITEM_LIST                      } from 'src/components/features/main/product-count-result-dialog/component';

import { RootState                            } from 'src/store';

const SLICE_NAME = 'main:product-count-result-dialog';

export interface MainProductCountResultDialogState {
  isOpened: boolean;
  selectedItem: RadioGroupItem;
  commentValue: string;
}

const initialState: MainProductCountResultDialogState = {
  isOpened: false,
  selectedItem: RADIO_ITEM_LIST[0],
  commentValue: '',
};

export const mainProductCountResultDialogSlice = createSlice({
  name: SLICE_NAME,
  initialState: { ...initialState },
  reducers: {
    initDialog: (state, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload;
    },
    setIsOpened: (state) => {
      state.isOpened = !state.isOpened;
    },
    setSelectedItem: (state, action: PayloadAction<RadioGroupItem>) => {
      state.selectedItem = action.payload;
    },
    setCommentValue: (state, action: PayloadAction<string>) => {
      state.commentValue = action.payload;
    },
    resetState: (state) => {
        state.selectedItem = initialState.selectedItem;
        state.commentValue = initialState.commentValue;
    }
  },
});

const selectIsOpened = (state: RootState) =>
  state.mainProductCountResultDialog.isOpened;
const selectSelectedItem = (state: RootState) =>
  state.mainProductCountResultDialog.selectedItem;
const selectCommentValue = (state: RootState) =>
  state.mainProductCountResultDialog.commentValue;

export const mainProductCountResultDialogSelectors = {
  selectIsOpened,
  selectSelectedItem,
  selectCommentValue,
};

export const mainProductCountResultDialogActions =
  mainProductCountResultDialogSlice.actions;

export default mainProductCountResultDialogSlice.reducer;
